import {Carousel, Fancybox} from "@fancyapps/ui";

export default context => {
    const loadGallery = async function (id) {
        let data = {}
        let apiBaseUrl = process.env.API_V2_EXTERNAL_URL;
        if (!/^https?:\/\//i.test(apiBaseUrl)) {
            apiBaseUrl = 'https://' + apiBaseUrl;
        }
        try {
            data = await $.get(apiBaseUrl + '/api/v2/groups/' + id + '/gallery')
            // Real message.
            data = data.code === 200
                ? data.data
                : {}
        } catch {
            try {
                data = await $.get(`/site/options/get-default-gallery/${cid}`)
            } catch {
                data = {}
            }
        }
        return data;
    }

    $('[data-gallery-view-id]', context).each(async function () {
        const container = $(this)
        const galleryData = await loadGallery(container.data('gallery-view-id'))
        if (!galleryData.images) {
            return
        }
        container.removeClass(['gallery-slider', 'gallery-grid']).addClass('gallery-' + galleryData.galleryStyleType)
        container.innerHTML = '';
        if (galleryData.galleryStyleType === 'grid') {
            const max = container.data('gallery-view-max-items') || 4
            const count = galleryData.images.length
            galleryData.images.slice(0, max - 1).forEach(item => {
                container.append($(renderNormalItem(item)))
            })
            galleryData.images.slice(max - 1, max).forEach(item => {
                container.append(max >= count ? renderNormalItem(item) : renderMoreItem(item, count - max))
            })
            galleryData.images.slice(max).forEach(item => {
                container.append(renderHiddenItem(item))
            })
        } else if (galleryData.galleryStyleType === 'slider') {
            galleryData.images.forEach(item => {
                container.append($(renderNormalItem(item)))
            })
            new Carousel(container[0], {
                slidesPerPage: 1,
                dragFree: true,
                center: true,
                fill: false,
                Dots: false,
                infinite: true,
            });
        }

        Fancybox.bind('[data-gallery-view-id="' + container.data('gallery-view-id') + '"] [data-fancybox="gallery-view"]', {
            Toolbar: {
                display: [
                    "close",
                ],
            },
        })
    })

    const renderNormalItem = imageData => {
        return `<div class="carousel__slide"><a class="gallery-item" data-fancybox="galllery-view" data-caption="${imageData.credit}" href="${imageData.url}"><img src="${imageData.thumbnailUrl}"></a></div>`
    }

    const renderMoreItem = (imageData, left) => {
        return `<div class="carousel__slide"><a class="gallery-item" data-fancybox="galllery-view" data-caption="${imageData.credit}" href="${imageData.url}"><img src="${imageData.thumbnailUrl}"><div class="gallery-overlay">+ ${left}</div></a></div>`
    }
    const renderHiddenItem = imageData => {
        return `<div class="carousel__slide"><a class="gallery-item" data-fancybox="galllery-view" data-caption="${imageData.credit}" href="${imageData.url}"></a></div>`
    }
}
